@import '../../../utils/global.module.less';

.lockedInput {
    filter: grayscale(0.5);
    cursor: not-allowed !important;
}
.messages {
    background-color: '#EAEAEA';
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.customShadow:before {
    content: '';
    background-color: transparent;
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    border-radius: 0px 20px 20px 0px;
    .shadow();
}
.input {
    flex: 1;
    display: flex;
    align-items: flex-end;
    min-height: 50px;

    textarea {
        &:focus {
            border: none !important;
            border-top: 2px dashed #7c7c7c !important;
        }

        outline: 0;
        background-color: transparent;
        border: none !important;
        border-top: 2px dashed #e0e0e0 !important;
        padding: 10px;
        margin: 0;
        margin-left: 10px;
        width: 100%;

        font-size: 20px;
        font-family: inherit;
        line-height: 1.5;

        // Height and scroll control
        min-height: 50px;
        max-height: 220px;
        height: auto;

        overflow-y: auto;
        resize: none;

        // Scrollbar styling
        scrollbar-width: thin;
        scrollbar-color: #c0c0c0 transparent;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #c0c0c0;
            border-radius: 3px;
        }
    }
}

.uploadButton {
    min-height: 50px;
    height: 50px;
    font-family: Hanken Grotesk !important;
    font-size: 20px !important;
    font-weight: bold;
    border-radius: 0 !important;
    padding: 6px 6px 6px 6px !important;
    border-color: transparent !important;
    flex-shrink: 0;
    align-self: flex-end;
    margin: 0;
}

.cancelUploadButton {
    .uploadButton();
    background-color: hsl(0deg 65.87% 58.48%) !important;
    &:hover {
        background-color: hsl(0deg 65.87% 48.48%) !important;
    }
}
.sendButton {
    width: 100px;
    min-height: 50px;
    height: 50px;
    font-family: Hanken Grotesk !important;
    font-size: 20px !important;
    font-weight: bold;
    border-radius: 0 0 20px 0 !important;
    flex-shrink: 0;
    align-self: flex-end;
    padding: 0;
    margin: 0;
}

.taskTitle {
    padding-bottom: 8px;
    padding-right: 10px;
    background-color: #fcfcfd;

    position: absolute;
    top: 10px;
    left: 15px;
    max-width: calc(100% - 30px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Hanken Grotesk !important;
    z-index: 10;
    :global(.taskSectionTitle) {
        font-size: 16px;
        font-family: LustTextItalic;
        color: #102442;
    }
    :global(.taskNameTitle) {
        font-size: 16px;
        font-family: LustTextItalic;
        color: #102442;
        font-weight: 600;
    }
}
.clearButton {
    position: absolute;
    right: -6px;
    bottom: 40px;
    width: 35px;
    font-family: Hanken Grotesk !important;
    font-size: 20px !important;
    font-weight: bold;
    border: 0 !important;
    z-index: 10;
    opacity: 0.1;
    color: black;
    padding: 2px !important;
    transition: opacity 0.3s !important;
    background-color: transparent !important;
    &:hover {
        opacity: 1;
        cursor: pointer;
    }
}
.attachmentBubble {
    background-color: #f0f0f0;
    padding: 5px 10px;
    border-radius: 15px;
    margin-bottom: 5px;
    font-size: 14px;
    font-family: Hanken Grotesk;
    max-width: 200px;
    word-break: break-word;
    cursor: pointer;
    &:hover {
        background-color: #e0e0e0;
        font-weight: 500;
    }
}

.inputLineOffset {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    min-height: 50px;
    max-height: 220px;
    padding: 0;
    margin: 0;
    gap: 0;
}
